(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["videos-enso"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
    var video1 = document.getElementById('ensoVideo');
    var button1 = document.getElementById('videoControl');
    var video2 = document.getElementById('ensoVideo2');
    var button2 = document.getElementById('videoControl2');
  
    function setupVideoControls(video, button) {
      // Reproducir automáticamente al cargar y pausar después de 4 segundos
      video.play(); // Inicia la reproducción al cargar la página
      setTimeout(function() {
        video.pause();
        button.innerText = 'PLAY';
      }, 3500); // Detiene el vídeo después de 4 segundos
  
      // Asegurar que el vídeo se pausa al finalizar
      video.addEventListener('ended', function() {
        video.pause();
        button.innerText = 'PLAY';
      }, false);
  
      // Controlar el video manualmente con el botón
      button.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          button.innerText = 'PAUSE';
        } else {
          video.pause();
          button.innerText = 'PLAY';
        }
      }, false);
    }
  
    // Configurar los controles de vídeo para ambos vídeos
    setupVideoControls(video1, button1);
    setupVideoControls(video2, button2);
  });
  
  
  
  } catch(e) { console.error(e); }
})();
})();
